import { render, staticRenderFns } from "./schatting-jaarlijks-elektriciteitsverbruik.vue?vue&type=template&id=438f21c6"
import script from "./schatting-jaarlijks-elektriciteitsverbruik.vue?vue&type=script&lang=js"
export * from "./schatting-jaarlijks-elektriciteitsverbruik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports